<div class="flex flex-col p-6">
  <div class="aligner mx-auto mb-4 mt-6 w-[154px]">
    <img src="assets/images/sensei/sensei-shocked.svg" alt="'assessment.delete_popup.delete_assessment' | transloco" />
  </div>
  <h3 class="text-display-xs text-primary mb-2 text-center font-semibold">Are you sure you want to skip?</h3>
  <p class="text-secondary text-md mb-9 text-center">Only skip questions if you <u>truly</u> cannot attempt them.</p>
  <div class="flex flex-col gap-2">
    <dojo-button (click)="closeDialog()" [customColor]="'sky'">Keep reviewing</dojo-button>
    <dojo-button (click)="skipQuestion()" [fill]="'outline'" [customColor]="'sky'"> Skip question </dojo-button>
  </div>
</div>
